import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import reportWebVitals from 'reportWebVitals';

import { AppProvider } from 'context';
import AppLayout from 'components/organisms/AppLayout';
import AppShareLayout from 'components/organisms/AppShareLayout';
import AppGalleryLayout from 'components/organisms/AppGalleryLayout';

import config from 'config';

import './index.scss';

enum LayoutOptionsType {
  APP_LAYOUT = 'appLayout',
  APP_SHARE_LAYOUT = 'appShareLayout',
  APP_GALLERY_LAYOUT = 'appGalleryLayout',
};

const Layouts = {
  appLayout: AppLayout,
  appShareLayout: AppShareLayout,
  appGalleryLayout: AppGalleryLayout,
};

const renderLayout = (layout: LayoutOptionsType) => {
  const component = Layouts[layout];
  return React.createElement(component, {
      key: layout,
  });
}

// nginx server sets index of build at /previews which differs from localhost
const subdir = config.hostEnv === 'development' ? '/' : '/previews/';
const routes = [
  {
    path: `${subdir}:creative_id`,
    component: renderLayout(LayoutOptionsType.APP_LAYOUT),
  },
  {
    path: `${subdir}share/:encoded_params`,
    component: renderLayout(LayoutOptionsType.APP_SHARE_LAYOUT),
  },
  {
    path: `${subdir}gallery/:encoded_params`,
    component: renderLayout(LayoutOptionsType.APP_GALLERY_LAYOUT),
  },
];

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <Router>
        <Routes>
          {routes.map((route, i) => (
            <Route
              key={i}
              path={route.path}
              element={route.component}
            />
          ))}
        </Routes>
      </Router>
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
